<template>
  <div>
    <v-bottom-sheet
      v-model="sheet"
      hide-overlay
      persistent
    >
      <v-sheet class="px-3">
        <map-legend
          v-if="tab===0"
          dense
        />
        <select-indicator
          v-if="selectIndicator && tab===1"
          dense
          class="pt-2"
        />
        <selected-infos
          v-if="tab===selectedNumber"
          dense
        />
        <div style="height:60px" />
      </v-sheet>
    </v-bottom-sheet>
    <v-bottom-navigation
      v-model="tab"
      style="z-index:300"
      :color="sheet ? 'primary' : ''"
    >
      <v-btn
        style="min-width:120px"
        small
        class="pa-0"
        @click="toggleSheet"
      >
        <span>Légende</span><v-icon>mdi-filter</v-icon>
      </v-btn>
      <v-btn
        v-if="selectIndicator"
        style="min-width:120px"
        small
        class="pa-0"
        @click="toggleSheet"
      >
        <span>Calcul de l'indicateur</span><v-icon>mdi-magnify</v-icon>
      </v-btn>
      <v-btn
        v-if="selected"
        style="min-width:120px"
        small
        class="pa-0"
        @click="toggleSheet"
      >
        <span>Sélection</span><v-icon>mdi-selection-marker</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </div>
</template>

<script>
  import SelectedInfos from './sections/selected-infos.vue'
  import SelectIndicator from './sections/select-indicator.vue'
  import MapLegend from './sections/map-legend.vue'
  import { mapState, mapGetters } from 'vuex'

  export default {
    components: {
      SelectedInfos,
      SelectIndicator,
      MapLegend,
    },
    data () {
      return {
        sheet: true,
        tab: 0,
      }
    },
    computed: {
      ...mapState(['selected']),
      ...mapGetters(['config']),
      selectIndicator () {
        return (this.config.numerator.valueField && this.config.numerator.valueField.length > 1) || (this.config.denominator.type !== 'none' && this.config.denominator.valueField && this.config.denominator.valueField.length > 1)
      },
      selectedNumber () {
        return this.selectIndicator ? 2 : 1
      },
    },
    watch: {
      selected (value) {
        if (value) this.tab = this.selectedNumber
        else this.tab = null
        this.sheet = !!value
      },
      tab (newV, oldV) {
        this.sheet = (newV !== null && oldV !== null)
      },
    },
    methods: {
      toggleSheet (e) {
        this.sheet = !this.sheet
      },
    },
  }
</script>

<style lang="css" scoped></style>
